export { default } from './theme.component';
